import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TokenService {

  private readonly TOKEN_KEY = 'jwt_token';
  private readonly EXPIRES_IN_KEY = 'jwt_expires_in';
  private readonly EXPIRES_AT_KEY = 'jwt_expires_at';

  get(): string | null {
    return localStorage.getItem(this.TOKEN_KEY) ?? sessionStorage.getItem(this.TOKEN_KEY);
  }

  getExpiresIn(): number | null {
    return this.getNumericMeta(this.EXPIRES_IN_KEY);
  }

  getExpiresAt(): number | null {
    return this.getNumericMeta(this.EXPIRES_AT_KEY);
  }

  isRemembered(): boolean {
    return localStorage.getItem(this.TOKEN_KEY) !== null;
  }

  isExpiredOrExpiringSoon(bufferMs = 0): boolean {
    const expiresAt = this.getExpiresAt();
    if (expiresAt === null) return false;

    return expiresAt <= Date.now() + bufferMs;
  }

  set(token: string, remember: boolean, expiresIn?: number): void {
    const storage = remember ? localStorage : sessionStorage;
    const otherStorage = remember ? sessionStorage : localStorage;

    this.clearStorage(otherStorage);

    storage.setItem(this.TOKEN_KEY, token);

    if (expiresIn !== undefined) {
      storage.setItem(this.EXPIRES_IN_KEY, String(expiresIn));
      storage.setItem(this.EXPIRES_AT_KEY, String(Date.now() + expiresIn * 1000));
      return;
    }

    storage.removeItem(this.EXPIRES_IN_KEY);
    storage.removeItem(this.EXPIRES_AT_KEY);
  }

  remove(): void {
    this.clearStorage(localStorage);
    this.clearStorage(sessionStorage);
  }

  private getNumericMeta(key: string): number | null {
    const value = localStorage.getItem(this.TOKEN_KEY)
      ? localStorage.getItem(key)
      : sessionStorage.getItem(key);

    if (!value) return null;

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  private clearStorage(storage: Storage): void {
    storage.removeItem(this.TOKEN_KEY);
    storage.removeItem(this.EXPIRES_IN_KEY);
    storage.removeItem(this.EXPIRES_AT_KEY);
  }
}
